import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Brain, Trash2 } from 'lucide-react';
import { apiErrorMessage } from '../lib/apiError';
import '../styles/dnaOnboarding.css';

const API = `${(process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '')}/api/me/memory`;

// "Meko'nun hafızası": yalnız kullanıcının açıkça kalıcı dediği tercihler. Silmek DNA'yı değiştirmez.
export default function MemoryCard() {
  const [memory, setMemory] = useState(null), [error, setError] = useState(''), [busy, setBusy] = useState('');
  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(API, { timeout: 15000 });
      if (!data || !Array.isArray(data.preferences)) throw new Error('invalid_memory');
      setMemory(data); setError('');
    }
    catch (err) { setError(apiErrorMessage(err, 'Hafızan yüklenemedi.')); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const remove = async id => {
    setBusy(id); setError('');
    try { await axios.delete(`${API}/preferences/${encodeURIComponent(id)}`, { timeout: 15000 });
      setMemory(m => ({ ...m, preferences: m.preferences.filter(p => p.id !== id) })); }
    catch (err) { setError(apiErrorMessage(err, 'Hafıza kaydı silinemedi. Tekrar dene.')); }
    finally { setBusy(''); }
  };
  return <section className="dna-memory" aria-labelledby="memory-title" data-testid="memory-card">
    <h2 id="memory-title" className="text-lg font-bold flex items-center gap-2"><Brain size={18} aria-hidden="true" />Meko’nun hafızası</h2>
    {memory && <p>{memory.note}</p>}
    {error && <p role="alert">{error}</p>}
    {memory && (memory.preferences.length ? <ul>{memory.preferences.map(p => <li key={p.id} data-testid={`memory-item-${p.id}`}>
      <span>{p.label}</span>
      <button type="button" className="text-action" disabled={busy === p.id} onClick={() => remove(p.id)} aria-label={`${p.label} kaydını sil`}><Trash2 size={14} aria-hidden="true" />Sil</button>
    </li>)}</ul> : <p data-testid="memory-empty">Henüz kalıcı bir tercih kaydetmedin. Meko’ya “bunu bir daha önerme” ya da “genelde Anadolu Yakası’nda çalışırım” dediğinde burada görürsün.</p>)}
  </section>;
}
